import { render, staticRenderFns } from "./claimActionDialog.vue?vue&type=template&id=3c0f13af"
import script from "./claimActionDialog.vue?vue&type=script&lang=js"
export * from "./claimActionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports